module.exports = __webpack_public_path__ + "img/4-01-05-call.85b48714.svg";